import { IconBook2 } from "@tabler/icons-react";
import type { FC } from "react";
import {
  TeammateLabel,
  type TeammateLabelProps,
} from "../teammate/teammateLabel.js";

export interface CustomerTimelineCallParticipant extends TeammateLabelProps {
  id: string;
}

export interface CustomerTimelineCallProps {
  title: string;
  participants: readonly CustomerTimelineCallParticipant[];
  playbookNames?: readonly string[];
  duration?: string;
}

/** Recording facts for a single call, with no data fetching or route knowledge. */
export const CustomerTimelineCall: FC<CustomerTimelineCallProps> = (props) => {
  const { title, participants, playbookNames = [], duration } = props;

  return (
    <div className="min-w-0">
      <h3 className="text-sm font-medium text-foreground">{title}</h3>

      <div className="mt-2 flex flex-wrap items-center gap-1 text-xs text-muted-foreground">
        {participants.length > 0 && (
          <span className="inline-flex flex-wrap items-center gap-x-3 gap-y-1">
            {participants.map((participant) => (
              <TeammateLabel
                key={participant.id}
                name={participant.name}
                kind={participant.kind}
                isAvatarHidden={participant.isAvatarHidden}
              />
            ))}
          </span>
        )}

        {playbookNames.map((name, index) => (
          <span key={name} className="inline-flex items-center gap-1">
            {(participants.length > 0 || index > 0) && (
              <span aria-hidden="true">·</span>
            )}
            <span className="inline-flex items-center gap-1.5 text-foreground">
              <IconBook2
                aria-hidden="true"
                className="size-4 shrink-0 text-muted-foreground"
              />
              {name}
            </span>
          </span>
        ))}

        {duration && (
          <span className="inline-flex items-center gap-1">
            {(participants.length > 0 || playbookNames.length > 0) && (
              <span aria-hidden="true">·</span>
            )}
            {duration}
          </span>
        )}
      </div>
    </div>
  );
};
